module.exports = __webpack_public_path__ + "static/img/gzb_logo.14d31557.png";